import React from 'react';
import { connect } from "react-redux";
import './../main.scss'
import { Row, Col, Form } from 'react-bootstrap'
import './themeColors.scss'
import { withNamespaces } from 'react-i18next';
import Flags from 'country-flag-icons/react/1x1'
import { store } from 'react-notifications-component';
//import get_template_invoice from '../../../API/server/get_template_invoice'
//import update_template_invoice from '../../../API/server/update_template_invoice.js'
import updateUser from '../../../API/Provider/PutUser'
import ToggleButton from 'react-toggle-button'
import { ImCheckmark } from 'react-icons/im'
import { IconContext } from 'react-icons'
import history from '../../../history';

export class General extends React.Component{
    state={
        list: [],
        formatedList: [],
        selectedInvoiceTemplate: {}
    }

    componentDidMount = async () =>{    
        const { t } = this.props
        document.title= t('General')

        this.setState({loading: true})    
        /*
        let lista = await get_template_invoice(this.props.user.username, "")
        if(lista.data.data.length > 0){
            this.setState({
                list: lista.data.data
            })
        }

        let formatedList = []
        await lista.data.data
        .map((data, index) =>{
            let oneItem = {value: data.template_uuid , label: data.invoice_name }
            formatedList.push(oneItem)
            return null
        })

        await this.setState({
            formatedList: formatedList,
            selectedInvoiceTemplate: formatedList[0]
        })
        */
        this.setState({loading: false})    
    }

    updateUser = async () =>{
        await updateUser(
            this.props.user,
            this.props.user.provider_uuid
        )
    }

    handleColapsed = async () => {    
        await this.props.mapState("USER_MAP_SETTINGS", {column: "asideColapsed", value: !this.props.user.user_web_properties.settings.asideColapsed});

        await this.updateUser()
    }

    handleBG = async () => {
        await this.props.mapState("USER_MAP_SETTINGS", {column: "asideBg", value: !this.props.user.user_web_properties.settings.asideBg});

        await this.updateUser()
    }

    changeLanguage = async (lng) =>{
        const { i18n } = this.props;
        i18n.changeLanguage(lng);

        await this.props.mapState("USER_MAP_SETTINGS",  {column: "language", value: lng})

        await this.updateUser()
    }

    changeThemePallet = async (color) => {
        await this.props.mapState("USER_MAP_SETTINGS", {column: "themeColor", value: color});

        document.documentElement.className = "";      
        document.documentElement.classList.add(`theme-`+ color);
        
        await this.updateUser()
    }

    generickiPredlozak = async (e) => {
        const {t} = this.props

        if(this.state.list.length !== 0 ){
            store.addNotification({
                title: t('Error!'),
                message: t('Invoice Template list is empty'),
                type: "danger",
                insert: "top",
                container: "top-right",
                animationIn: ["animate__animated", "animate__fadeIn"],
                animationOut: ["animate__animated", "animate__fadeOut"],
                dismiss: {
                    duration: 5000,
                    pauseOnHover: true
                }
            });
        }
        else if(this.state.list.filter((data) => data.is_active === true).length === 0){
            store.addNotification({
                title: t('Error!'),
                message: t('There is no active ivoice templates'),
                type: "danger",
                insert: "top",
                container: "top-right",
                animationIn: ["animate__animated", "animate__fadeIn"],
                animationOut: ["animate__animated", "animate__fadeOut"],
                dismiss: {
                    duration: 5000,
                    pauseOnHover: true
                }
            });
        }
        else{
            await this.props.toggleSettings("GENERICKI_PREDLOZAK_RACUNA_TOGGLER")
        }
    }

    izradiPredlozak(){
        history.push("settings/predlozakRacuna")
    }

    /*
    handleInvoiceTemplateChange = async (e) =>{
        this.setState({
            selectedInvoiceTemplate: e
        })

        let izabraniPredlozak = this.state.list.filter((data) => data.template_uuid === this.state.selectedInvoiceTemplate.value)
        izabraniPredlozak[0].is_active = false;

        await update_template_invoice(izabraniPredlozak[0])

        this.componentDidMount()
    }
    */


    render(){  
        const { t } = this.props

        const boje = [
            { name: "darkBlue", colorCode: "#162A6C"},
            { name: "red", colorCode: "#E62020"},
            { name: "black", colorCode: "#000"},
            { name: "green", colorCode: "#008C4D"},
            { name: "yellow", colorCode: "#FAA700"},
            { name: "orange", colorCode: "#B53F00"},
            { name: "purple", colorCode: "#7231F5"}
        ]
        
        return(     
            <main>
               
                <Row>
                    <Col xl="3" lg="4" md="6" sm="12">
                        <div>
                            <h3>{t('Menu')}</h3>
                            <hr/>    
                        </div>
                     
                        <Row className="mb-4 mt-2">
                            <Col className="d-flex">                                   
                                <ToggleButton
                                    inactivelabel={"X"}
                                    activelabel={<IconContext.Provider value={{ color: "white", className: "global-class-name" }}>
                                    <div>
                                        <ImCheckmark />
                                    </div>
                                    </IconContext.Provider>}
                                    value={this.props.user.user_web_properties.settings.asideColapsed}
                                    onToggle={(value) => this.handleColapsed(value)}
                                />
                                <h5 className="mb-0 d-flex ms-4 align-items-center">{t('Collapse')}</h5>
                            </Col>
                        </Row>
                   
                        <div>
                            <h3>{t('Language')}</h3>  
                            <hr/>       
                        </div>

                        <div className="mb-4 mt-2">
                            <Flags.HR title="Croatia"
                                className={`flag ${this.props.user.user_web_properties.settings.language === 'hr' ? 'activeFlag' : null}`}
                                onClick={() => this.changeLanguage("hr")} 
                            />
                            <Flags.US title="United States"
                                className={`flag ${this.props.user.user_web_properties.settings.language === 'en' ? 'activeFlag' : null}`}
                                onClick={() => this.changeLanguage("en")}
                            />
                        </div>

                        <div>
                            <h3>{t('Theme color')}</h3>   
                            <hr/>      
                        </div>
                        <div>
                            {boje.map((opis, index) => 
                                <span key={index}>
                                    <Form.Control  type="radio" className="btn-check d-none" key={opis.name} name="themeColor" id={opis.name}/>
                                    <Form.Label htmlFor={opis.name} key={"Form.Label-" + opis.name}> 
                                        {this.props.user.user_web_properties.settings.themeColor === opis.name ?
                                            <span key={"span-" + opis.name} className="me-2" style={{ color: opis.colorCode }}>
                                                <i 
                                                    key={"i-" + opis.name} 
                                                    className="fas fa-check-circle fa-2x"
                                                />
                                            </span>
                                        :
                                            <span key={"span-" + opis.name} className="me-2" style={{ color: opis.colorCode }}>
                                                <i
                                                    key={"i-" + opis.name}
                                                    className="fas fa-circle fa-2x" 
                                                    onClick={() => this.changeThemePallet(opis.name)}
                                                />
                                            </span>
                                        }
                                    </Form.Label>
                                </span>
                            )}
                        </div>
                    </Col>
                </Row>
            </main>
        )
    }  
}

const mapStateToProps = state => {
    return {
        user: state.user
    };
};
  
const mapDispatchToProps = dispatch => {
    return {
      mapState: (type, data) => dispatch({ type: type, data: data}),
      API: (type, data) => dispatch({ type: type, data: data}),
      toggleSettings: (type) => dispatch({ type: type})  
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withNamespaces()(General));
